import Logo from '@passkeys/ui/logo';

import { cn } from '@/ui/utils/classnames';

export interface AvatarProps {
  shape: 'rounded' | 'squared';
  size: 24 | 36;
}

function Avatar({ shape, size }: AvatarProps) {
  return (
    <div
      className={cn(
        'flex flex-none items-center justify-center',
        'border border-solid border-[rgb(from_var(--collapsed-avatar-border-color,_theme(colors.black))_r_g_b_/_6%)]',
        'bg-[color:var(--collapsed-avatar-bg-color,_theme(colors.pink.500))]',
        shape === 'rounded' && 'rounded-full',
        shape === 'squared' && 'rounded-md',
      )}
      style={{ width: size, height: size }}
    >
      <Logo
        className="fill-[color:--collapsed-avatar-logo-color,theme(colors.black)]"
        size={size === 24 ? 16 : 22}
      />
    </div>
  );
}

export default Avatar;
